import React from 'react';
import '../assets/css/main.css';
import '../assets/css/nice-select2.css';
import '../assets/css/swiper-bundle.min.css';
import {Notice, initForms, initLayoutScripts} from '../assets/js/notice.js'

export default class EmpProfile extends React.Component {
    constructor(props) {
        super(props);

        this.state = { lname: props.lname, fname: props.fname, sname: props.sname, email: props.email, tel: props.tel, emp_id: props.emp_id, UID: props.UID, profile: props.profile,
                       loading: false, error_messages: props.error_messages, update_error_messages_callback: props.update_error_messages_callback};

        //Если пользователь авторизован как клиент, меняем страницу на главную
        if(localStorage.getItem('accessToken'))
            window.location = "/";

        //Если пользователь не авторизован, перенаправляем его на страницу входа
        if(!localStorage.getItem('empAccessToken'))
            window.location = "/emplogin";
    }

    componentDidUpdate(prevProps) {
        //Если есть ошибки, выводим всплывающее окно с ними
        if(this.state.error_messages.length > 0)
            Notice.show(this.state.error_messages.join('<br/>'));

        if(prevProps.lname !== this.props.lname)
            this.setState({lname: this.props.lname});
        if(prevProps.fname !== this.props.fname)
            this.setState({fname: this.props.fname});
        if(prevProps.sname !== this.props.sname)
            this.setState({sname: this.props.sname});
        if(prevProps.email !== this.props.email)
            this.setState({email: this.props.email});
        if(prevProps.tel !== this.props.tel)
            this.setState({tel: this.props.tel});
        if(prevProps.emp_id !== this.props.emp_id)
            this.setState({emp_id: this.props.emp_id});
        if(prevProps.UID !== this.props.UID)
            this.setState({UID: this.props.UID});
        if(prevProps.profile !== this.props.profile)
            this.setState({profile: this.props.profile});
        if(prevProps.error_messages !== this.props.error_messages)
            this.setState({error_messages: this.props.error_messages});
        if(prevProps.update_error_messages_callback !== this.props.update_error_messages_callback)
            this.setState({update_error_messages_callback: this.props.update_error_messages_callback});
    }

    componentDidMount() {
        //Инициализируем скрипты от верстальщиков
        initLayoutScripts();
        Notice.setHideCallback(() => { this.setState({error_messages: []}); this.state.update_error_messages_callback([]); });
    }

    render() {
        return (
            <>
                {this.state.loading &&
                <div class="pre-loader">
                    <div class="loader-spinner">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                }

                <div class="profile">
                    <div class="flex-row align-center">
                        {this.state.profile.avatar && this.state.profile.avatar.length > 0 && <span class="profile--photo" style={{backgroundImage: `url(data:image/jpeg;base64,${this.state.profile.avatar})`}}></span>}
                        {(!this.state.profile.avatar || this.state.profile.avatar.length === 0) && <span class="profile--photo-null">{((this.state.lname && this.state.lname.length > 0) ? this.state.lname.charAt(0) : 'X') +
                                                                                                  ((this.state.fname && this.state.fname.length > 0) ? this.state.fname.charAt(0) : 'Y')}</span>}
                        <p class="profile--name">
                            <div>{((this.state.lname) ? this.state.lname : "") + " "}</div>
                            <div>
                            {((this.state.fname) ? this.state.fname : "") + " " +
                            ((this.state.sname) ? this.state.sname : "")}
                            </div>
                        </p>
                    </div>
                    <div class="flex-row profile--info">
                        <div class="col">
                            <p class="profile--title">
                                МОИ ДАННЫЕ
                            </p>
                            <div class="profile--field">
                                <div class="profile--field__title">
                                    <span class="text">
                                        Электронная почта
                                    </span>
                                    <span class="icon">
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.9998 13.2917V15.125M6.4165 9.19307C6.84864 9.16667 7.38138 9.16667 8.0665 9.16667H13.9332C14.6183 9.16667 15.1511 9.16667 15.5832 9.19307M6.4165 9.19307C5.87721 9.22598 5.4946 9.30004 5.16803 9.46642C4.65058 9.73005 4.22989 10.1507 3.96624 10.6682C3.6665 11.2565 3.6665 12.0265 3.6665 13.5667V14.85C3.6665 16.3902 3.6665 17.1602 3.96624 17.7485C4.22989 18.266 4.65058 18.6866 5.16803 18.9503C5.75628 19.25 6.52636 19.25 8.0665 19.25H13.9332C15.4734 19.25 16.2434 19.25 16.8317 18.9503C17.3491 18.6866 17.7698 18.266 18.0334 17.7485C18.3332 17.1602 18.3332 16.3902 18.3332 14.85V13.5667C18.3332 12.0265 18.3332 11.2565 18.0334 10.6682C17.7698 10.1507 17.3491 9.73005 16.8317 9.46642C16.5051 9.30004 16.1224 9.22598 15.5832 9.19307M6.4165 9.19307V7.33333C6.4165 4.80203 8.46854 2.75 10.9998 2.75C13.5311 2.75 15.5832 4.80203 15.5832 7.33333V9.19307" stroke="#7E7E7E" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                </div>
                                <div class="profile--field__value">
                                    <input type="text" class="input-transparent" value={this.state.email} readonly></input>
                                </div>
                            </div>
                            <div class="profile--field">
                                <div class="profile--field__title">
                                    <span class="text">
                                        Номер телефона
                                    </span>
                                    <span class="icon">
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.9998 13.2917V15.125M6.4165 9.19307C6.84864 9.16667 7.38138 9.16667 8.0665 9.16667H13.9332C14.6183 9.16667 15.1511 9.16667 15.5832 9.19307M6.4165 9.19307C5.87721 9.22598 5.4946 9.30004 5.16803 9.46642C4.65058 9.73005 4.22989 10.1507 3.96624 10.6682C3.6665 11.2565 3.6665 12.0265 3.6665 13.5667V14.85C3.6665 16.3902 3.6665 17.1602 3.96624 17.7485C4.22989 18.266 4.65058 18.6866 5.16803 18.9503C5.75628 19.25 6.52636 19.25 8.0665 19.25H13.9332C15.4734 19.25 16.2434 19.25 16.8317 18.9503C17.3491 18.6866 17.7698 18.266 18.0334 17.7485C18.3332 17.1602 18.3332 16.3902 18.3332 14.85V13.5667C18.3332 12.0265 18.3332 11.2565 18.0334 10.6682C17.7698 10.1507 17.3491 9.73005 16.8317 9.46642C16.5051 9.30004 16.1224 9.22598 15.5832 9.19307M6.4165 9.19307V7.33333C6.4165 4.80203 8.46854 2.75 10.9998 2.75C13.5311 2.75 15.5832 4.80203 15.5832 7.33333V9.19307" stroke="#7E7E7E" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                </div>
                                <div class="profile--field__value">
                                    <input type="text" class="input-transparent" value={this.state.tel} readonly></input>
                                </div>
                            </div>
                            <br/>
                            <div>
                                {((this.state.profile.QINFO) ? this.state.profile.QINFO : "")}
                            </div>
                        </div>
                        <div class="col">
                            <p class="profile--title">
                                МОЁ ОБРАЗОВАНИЕ
                            </p>
                            <div>
                                <ul>
                                    {this.state.profile.EDU && this.state.profile.EDU.map((data, index) =>
                                        <li key={index}>{data.edu_date} - {data.edu_org} по специальности «{data.edu_spec}»</li>
                                    )}
                                    {this.state.profile.SERTS && this.state.profile.SERTS.map((data, index) =>
                                        <li key={index + this.state.profile.EDU.length}>
                                            {data.serts_date} - {data.serts_org} по программе «{data.serts_sert}»
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
